module.exports = __webpack_public_path__ + "assets/img/moon.a28d5241.png";